<template>
  <div class="calculator-editor">
    <div class="container left-container">
      <div class="title-content">
        <span>公式列表</span>
      </div>
      <div class="tab-content">
        <div class="tab-content-header">
          <div class="tab-item" :class="tabVal === 'const' ? 'is-active' : ''" @click="tabVal = 'const'">
            <span>常量公式</span>
          </div>
          <div class="tab-item" :class="tabVal === 'variable' ? 'is-active' : ''" @click="tabVal = 'variable'">
            <span>变量</span>
          </div>
        </div>
        <div class="const-container" v-show="tabVal === 'const'">
          <div class="const-type-ul">
            <div
              v-for="constTypeItem in constTypes"
              :key="constTypeItem.key"
              class="const-type-li"
              :class="constTypeItem.key === constMode ? 'is-active' : ''"
              @click="constMode = constTypeItem.key"
            >
              <span>{{ constTypeItem.title }}</span>
            </div>
          </div>
          <div class="const-ul">
            <el-tooltip placement="right" v-for="constItem in funcArrFilters" :key="constItem._id">
              <div slot="content" :style="{ maxWidth: '200px', lineHeight: '16px' }">
                <div>{{ constItem._source.function_remark }}</div>
                <div :style="{ marginTop: '6px' }">{{ constItem._source.function_example }}</div>
              </div>
              <div class="const-li" @click="addValHandle(constItem._source.function_name)">
                <div class="const-li-title">{{ constItem._source.function_chinese_name }}</div>
                <div class="const-li-tip">{{ constItem._source.function_name }}</div>
              </div>
            </el-tooltip>
          </div>
        </div>
        <div class="variable-container" v-show="tabVal === 'variable'">
          <div class="variable-ul">
            <div
              v-for="columnItem in variableList"
              :key="columnItem.columnKey"
              class="variable-li"
              @click="addValHandle(columnItem.title)"
            >
              <span>{{ columnItem.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container right-container">
      <div class="title-content">
        <span>编辑公式</span>
      </div>
      <div class="edit-content">
        <div class="edit-header">
          <div
            v-for="symbolItem in symbolArr"
            :key="symbolItem.id"
            class="symbol-item"
            @click="addValHandle(symbolItem.key)"
          >
            <span>{{ symbolItem.key }}</span>
          </div>
        </div>
        <el-input
          ref="inputRef"
          class="edit-input"
          placeholder="请输入"
          v-model="code"
          :maxlength="800"
          type="textarea"
          :rows="7"
          resize="none"
          @keydown.enter.native="e => e.preventDefault()"
          @blur="initSelection"
          @input="changeCodeHandle"
        />
      </div>
      <div class="title-content" :style="{ margin: '10px 0 5px' }">
        <span>计算结果预览</span>
        <el-button type="primary" size="mini" :loading="previewLoading" @click="previewHandle">
          <span>预览</span>
        </el-button>
      </div>
      <div class="preview-content" v-loading="previewLoading">
        <el-table
          :empty-text="previewColumns.length > 0 ? '暂无数据' : '公式预览'"
          :data="previewList"
          height="100%"
          border
          size="mini"
          :header-cell-class-name="getHeaderCellClass"
        >
          <el-table-column type="index" width="50" v-if="previewColumns.length > 0" />
          <el-table-column
            v-for="(columnItem, columnIndex) in previewColumns"
            :key="`${columnItem}_${columnIndex}`"
            :label="columnItem"
            :property="columnItem"
          >
            <template slot-scope="{ row }">
              <span>{{ row[columnItem] }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { services } from '@/service';

export default {
  data() {
    return {
      code: '',
      funcArr: [],
      tabVal: 'const',
      constMode: 'normal',
      constTypes: [
        { title: '全部', key: 'normal' },
        { title: '文本', key: 'text' },
        { title: '日期', key: 'date' }
      ],
      symbolArr: [
        { id: 0, key: '+' },
        { id: 1, key: '-' },
        { id: 2, key: '/' },
        { id: 3, key: '*' },
        { id: 4, key: '(' },
        { id: 5, key: ')' }
      ],
      selectionInfo: {
        start: 0,
        end: 0
      },
      previewList: [],
      previewColumns: [],
      previewLoading: false
    };
  },
  props: {
    defaultCode: {
      type: String,
      default: ''
    },
    defaultColumns: {
      type: Array,
      default: () => []
    },
    currentField: {
      type: Object,
      default: () => null
    },
    courseId: {
      type: String,
      default: ''
    },
    fieldName: {
      type: String,
      default: ''
    },
    fieldType: {
      type: String,
      default: ''
    }
  },
  watch: {
    defaultCode: {
      handler(val) {
        if (val === this.code) {
          return;
        }
        this.previewList = [];
        this.previewColumns = [];
        this.selectionInfo = {
          start: val.length,
          end: val.length
        };
        this.code = val || '';
      },
      immediate: true
    }
  },
  computed: {
    funcArrFilters() {
      if (this.constMode === 'normal') {
        return this.funcArr;
      }
      let name = '';
      if (this.constMode === 'date') {
        name = '时间函数';
      }
      if (this.constMode === 'text') {
        name = '字符串函数';
      }
      return this.funcArr.filter(item => item._source.subtitle === name);
    },
    variableList() {
      if (!this.currentField) {
        return this.defaultColumns;
      }
      return this.defaultColumns.filter(item => item.columnKey !== this.currentField.columnKey);
    }
  },
  mounted() {
    this.getCalculatorFunction();
  },
  methods: {
    initSelection() {
      const inputEl = this.$refs.inputRef.$el.firstElementChild;
      this.selectionInfo = { start: inputEl.selectionStart, end: inputEl.selectionEnd };
    },
    async getCalculatorFunction() {
      try {
        this.funcArr = await services.labelRelation.getCalculatorFunction();
      } catch (err) {
        this.$error(err);
      }
    },
    addValHandle(val) {
      const start = this.selectionInfo.start;
      const preCode = this.code.slice(0, start);
      const nextCode = this.code.slice(this.selectionInfo.end);
      this.code = `${preCode}${val}${nextCode}`;
      this.changeCodeHandle(this.code);
      this.$refs.inputRef.focus();
      this.$nextTick(() => {
        const inputEl = this.$refs.inputRef.$el.firstElementChild;
        inputEl.selectionStart = start + val.length;
        inputEl.selectionEnd = inputEl.selectionStart;
      });
    },
    changeCodeHandle(code) {
      this.$emit('update:defaultCode', code);
    },
    async previewHandle() {
      const code = this.code;
      if (!code) {
        this.previewList = [];
        return;
      }
      try {
        this.previewLoading = true;
        const typeArr = this.fieldType.split('_');
        const params = {
          calculator_code: this.code,
          course_id: this.courseId,
          chinese_name: this.fieldName || '结果',
          type: typeArr[0],
          deputy_field_type: typeArr.slice(1).join('_')
        };
        const result = await services.labelRelation.testCalculator(params);
        this.previewColumns = result.field_sort.filter(text => !!text);
        this.previewList = result.data;
      } catch (err) {
        this.$error(err);
      } finally {
        this.previewLoading = false;
      }
    },
    getHeaderCellClass({ columnIndex }) {
      if (columnIndex === this.previewColumns.length) {
        return 'is-unit-cell';
      }
      return '';
    }
  }
};
</script>

<style lang="scss" scoped>
.calculator-editor {
  height: 460px;
  display: flex;

  $borderColor: #ebeef5;

  .container {
    box-sizing: border-box;
    height: 100%;
    display: flex;
    flex-direction: column;

    .title-content {
      font-size: 14px;
      color: #2c3443;
      line-height: 28px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 5px;
    }

    &.left-container {
      width: 240px;

      .tab-content {
        box-sizing: border-box;
        flex: 1;
        height: 0;
        width: 100%;
        border: 1px solid $borderColor;
        border-radius: 4px;
        background-color: #fff;

        .tab-content-header {
          box-sizing: border-box;
          height: 40px;
          border-bottom: 1px solid $borderColor;
          padding: 0 40px;
          display: flex;
          justify-content: space-between;

          .tab-item {
            font-size: 14px;
            color: #3d465a;
            position: relative;
            line-height: 40px;
            height: 100%;
            cursor: pointer;

            &::after {
              content: '';
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 2px;
              background-color: transparent;
            }

            &.is-active {
              color: #1991fb;

              &::after {
                background-color: #1991fb;
              }
            }
          }
        }

        .variable-container {
          height: calc(100% - 40px);
          overflow-y: auto;
          overflow-x: hidden;
          .variable-li {
            box-sizing: border-box;
            font-size: 14px;
            color: #3d465a;
            line-height: 17px;
            padding: 5px 10px;
            cursor: pointer;

            &:hover {
              background-color: #eaf6ff;
            }
          }
        }

        .const-container {
          box-sizing: border-box;
          height: calc(100% - 40px);
          display: flex;
          flex-direction: column;
          padding: 5px 0;

          .const-type-ul {
            box-sizing: border-box;
            width: 100%;
            padding: 0 10px;

            .const-type-li {
              display: inline-block;
              height: 24px;
              line-height: 24px;
              color: #3d465a;
              padding: 0 8px;
              background-color: transparent;
              margin-left: 6px;
              cursor: pointer;
              border-radius: 4px;

              &.is-active {
                background-color: #e8ebef;
              }

              &:first-child {
                margin-left: 0;
              }
            }
          }

          .const-ul {
            flex: 1;
            height: 0;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;
            .const-li {
              box-sizing: border-box;
              font-size: 12px;
              cursor: pointer;
              padding: 5px 10px;
              margin-top: 10px;

              &:first-child {
                margin-top: 0;
              }

              &:hover {
                background-color: #eaf6ff;
              }
              .const-li-title {
                color: #77839e;
                line-height: 17px;
              }
              .const-li-tip {
                color: #3d465a;
                line-height: 17px;
              }
            }
          }
        }
      }
    }

    &.right-container {
      flex: 1;
      width: 0;
      margin-left: 10px;

      .edit-content {
        border: 1px solid $borderColor;
        border-radius: 4px;
        height: 185px;
        .edit-header {
          box-sizing: border-box;
          height: 40px;
          white-space: nowrap;
          overflow-x: auto;
          overflow-y: hidden;
          border-bottom: 1px solid $borderColor;
          padding: 10px;
          background-color: #fff;

          .symbol-item {
            box-sizing: border-box;
            display: inline-block;
            width: 20px;
            height: 20px;
            line-height: 18px;
            text-align: center;
            margin-left: 10px;
            border: 1px solid $borderColor;
            cursor: pointer;
            vertical-align: top;

            &:first-child {
              margin-left: 0;
            }
          }
        }

        ::v-deep .edit-input {
          & > textarea {
            border: 0 !important;
          }
        }
      }

      .preview-content {
        box-sizing: border-box;
        width: 100%;
        flex: 1;
        height: 0;
        border-radius: 4px;
        background-color: #fff;

        ::v-deep .is-unit-cell {
          background-color: #fff4cb;
        }
      }
    }
  }
}
</style>
